import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const Reveal = ({ children, delay = 0, className, ...rest }) => (
  <motion.div className={className} variants={variants} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} transition={{ delay }} {...rest}>
    {children}
  </motion.div>
);

export const Stagger = ({ children, className, stagger = 0.12 }) => (
  <motion.div className={className} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}>
    {children}
  </motion.div>
);

export const Item = ({ children, className, ...rest }) => (
  <motion.div className={className} variants={variants} {...rest}>{children}</motion.div>
);
